<template>
  <log-entry :log-entry="logEntry" :resource-type="resourceType">
    <updated-properties
      :meta="meta"
      :properties="logEntry.properties"
      :relations="logEntry.relations"
      :resource-type="resourceType"
    ></updated-properties>
  </log-entry>
</template>

<script>
import UpdatedProperties from '@kanrisha/components/Elements/EventLog/UpdatedProperties';
import LogEntry from '@kanrisha/components/AppEventLog/LogEntry';

export default {
  components: {
    UpdatedProperties,
    LogEntry,
  },
  props: {
    logEntry: { type: Object, default: () => {} },
    resourceType: { type: String, default: () => '' },
    meta: { type: Object, default: () => {} },
  },
  setup() {
    return {};
  },
};
</script>
